import View from './view.js'
import { useFloating, offset, flip, autoUpdate } from '@floating-ui/react-dom'

function getBodyScale() {
  return document.body.classList.contains('mobile-scaled') ? 0.5 : 1
}

function positionFix(size, scale) {
  return {
    name: 'positionFix',
    fn({ x, y }) {
      return { x: x / scale, y: (size === 'small' ? y - 10 : y) / scale }
    },
  }
}

/**
 * I added a `logic` file in `TysiaSelectOneContent` to implement `useFloating` hook there and
 * keep the popover position without changes on each input selector click.
 * If I implemented on `logic` from parent, I had the issue where the popover position changed on each selector input click
 */
export default function Logic(props) {
  let scale = getBodyScale()

  let { refs, x, y, elements } = useFloating({
    open: props.isShowingOptions,
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [
      flip(),
      offset({
        mainAxis: props.size !== 'small' ? 5 : 12,
      }),
      positionFix(props.size, scale),
    ],
    whileElementsMounted: autoUpdate, // fixes scrolling issues
  })

  return (
    <View
      {...props}
      parentRef={refs.setReference}
      optionsRef={refs.setFloating}
      optionsLeft={x}
      optionsTop={y}
      optionsWidth={
        props.optionsWidth ?? elements.reference?.getBoundingClientRect()?.width
      }
    />
  )
}
